import { useState, useEffect } from "react";
import { useParams } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import SalesDetails from "../../components/sales/SalesDetail";
import api from "../../services/api";

export default function SalesDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [saleData, setSaleData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchSaleDetails = async () => {
            try {
                setLoading(true);
                const response = await api.get(`/api/sales/${id}`);

                if (response.data.status === 'success') {
                    setSaleData(response.data.data);
                } else {
                    setError('Erro ao carregar dados da venda');
                }
            } catch (err) {
                console.error('Erro ao buscar detalhes da venda:', err);
                setError('Erro ao carregar dados da venda');
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchSaleDetails();
        }
    }, [id]);

    return (
        <>
            <PageMeta
                title="Sellyo - Detalhes da Venda"
                description="Detalhes da transação"
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12">
                    {loading ? (
                        <div className="flex justify-center items-center h-64">
                            <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-blue-600" role="status">
                            </div>
                        </div>
                    ) : error ? (
                        <div className="p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800">
                            <span className="font-medium">Erro:</span> {error}
                        </div>
                    ) : (
                        <SalesDetails saleData={saleData} />
                    )}
                </div>
            </div>
        </>
    );
}